export const emailPattern =
  /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/;
export const phonePattern = /\b(?:03|04|13|61|\+61)[\s\d]{7,}\b/;
export const urlPattern =
  /(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+)(?:\/[^\s]*)?/;
